import connectToContext from '@slergberg/react-hoc-connect-to-context'

import Deck from '../Deck'
import PlayerContext from './PlayerContext'

export default connectToContext(PlayerContext, (state) => ({
  currentSlide: state.currentDeckSlide,
  nextSlide: state.nextDeckSlide,
  previousSlide: state.previousDeckSlide,
  slides: state.deckSlides,
  status: state.deckStatus,
  statusProgress: state.deckStatusProgress,
}))(Deck)
